export enum BeneficiaryErrorCodes {
  FAILED_TO_FETCH_CHECK_PAYEE = 'failed_to_fetch_check_payee',
  FAILED_TO_UPDATE_BENEFICIARY = 'failed_to_update_beneficiary',
  FAILED_TO_CREATE_BENEFICIARY = 'failed_to_create_beneficiary',
  INVALID_IBAN = 'invalid_iban',
  INVALID_BIC = 'invalid_bic',
  INVALID_ACCOUNT_NUMBER = 'invalid_account_number',
  INVALID_SORT_CODE = 'invalid_sort_code',
  ALREADY_FAVORITE = 'already_favorite',
  NOT_IN_FAVORITE = 'not_in_favorite',
  FAILED_TO_MARK_FAVORITE = 'failed_to_mark_favorite',
  BENEFICIARY_NOT_FOUND = 'beneficiary_not_found',
  INVALID_ACCOUNT_DETAILS_COP = 'invalid_account_details_cop',
}
